var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "113px",
    viewBox: "0 0 128 113",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Vita Header") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "63.627 45.7426421 63.627 0.152254048 0.132069214 0.152254048 0.132069214 45.7426421 63.627 45.7426421"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Vita-Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.4972497,88.1293188 L63.4972497,112.767355 C64.7650926,112.782959 66.050462,112.313471 67.0357231,111.354047 L89.6907975,88.1293188 L63.4972497,88.1293188 Z",
    id: "Fill-1",
    fill: "#DCEACD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4972497,75.3747398 L63.4972497,88.1292112 L89.6907975,88.1292112 L93.0159864,84.7203779 C93.0906764,84.6402017 93.1149439,84.5336588 93.1834323,84.449985 L102.035952,75.3747398 L63.4972497,75.3747398 Z",
    id: "Fill-3",
    fill: "#C0D9A5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(63.365180, 29.632098)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.132069214,45.7426421 L38.670772,45.7426421 L53.5958335,30.4424421 C61.6232582,22.2133517 64.8314238,10.8716493 63.2251839,0.152254048 L0.132069214,0.152254048 L0.132069214,45.7426421 Z",
    id: "Fill-5",
    fill: "#97C673",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126.590418,29.7844324 C125.519682,22.6393348 122.311516,15.7708181 116.961068,10.2857443 C103.582926,-3.42842 81.7710127,-3.42842 68.3928705,10.2857443 L63.4973036,15.3040205 L63.4973036,29.7844324 L126.590418,29.7844324 Z",
    id: "Fill-8",
    fill: "#59AF31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0335123,10.2856905 C-3.3443603,24.0001238 -3.3443603,46.3604024 10.0335123,60.0745667 L39.2130431,89.98755 C39.3769837,90.1554357 39.5740898,90.2649381 39.7407268,90.4290571 L60.1529433,111.354236 C61.0589306,112.282988 62.2698796,112.752476 63.4972766,112.767543 L63.4972766,15.3039667 L58.6019794,10.2856905 C45.2238372,-3.42847381 23.4113849,-3.42847381 10.0335123,10.2856905",
    id: "Fill-10",
    fill: "#4DA134"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthBanner);
export default __webpack_public_path__ + "static/media/HealthBanner.2437726d2efe7441a35d20611ed10ad4.svg";
export { ForwardRef as ReactComponent };